import { Wrapper } from './index.styles';

import Content from './content';
import Nav from './nav';
import WebsocketHandler from './websocket_handler';

export default function IndexPage() {
  return (
    <Wrapper>
      <Nav />
      <Content />
      <WebsocketHandler />
    </Wrapper>
  );
}
